import { appColors } from '@/src/theme'
import { Text } from '@chakra-ui/react'
import { FlexRow } from '../../flex'

export const customChatTheme = {
  h3: props => {
    const { children } = props
    return (
      <Text color={appColors.foreground} fontSize={'13px'} fontFamily={'Parabole'} mt={'8px'} mb={'2px'} fontWeight={600}>
        {children}
      </Text>
    )
  },
  p: props => {
    const { children } = props
    return (
      <Text color={appColors.foreground} fontSize={'13px'} fontFamily={'Parabole'}>
        {children}
      </Text>
    )
  },
  ol: props => {
    const { children } = props
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '8px',
          marginBottom: '8px',
          gap: '6px',
        }}
      >
        {children}
      </div>
    )
  },
  ul: props => {
    const { children } = props
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '8px',
          marginBottom: '8px',
          gap: '6px',
        }}
      >
        {children}
      </div>
    )
  },
  li: props => {
    const { children, index, ordered } = props
    return (
      <FlexRow gap={'4px'}>
        <Text color={appColors.foreground} fontSize={'13px'} fontFamily={'Parabole'}>
          {ordered ? `${index + 1}.` : '•'}
        </Text>
        <Text color={appColors.foreground} fontSize={'13px'} fontFamily={'Parabole'}>
          {children}
        </Text>
      </FlexRow>
    )
  },
}
